import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import mapboxgl from "!mapbox-gl"
import { marked } from "marked"
import "mapbox-gl/dist/mapbox-gl.css"

const Contact = () => {
  const data = useStaticQuery(graphql`
      query ContactQuery {
          allContentfulKontakt {
              nodes {
                  title
                  description {
                      description
                  }
                  phone
                  email
              }
          }
          site {
              siteMetadata {
                  mapboxToken
              }
          }
      }
  `)

  mapboxgl.accessToken = data.site.siteMetadata.mapboxToken

  useEffect(() => {
    let map
    if (typeof window !== "undefined") {
      map = new mapboxgl.Map({
        container: "map-container",
        style: "mapbox://styles/vrgz/ckhkhzkkf5cyr19les9zqmqbw",
        center: [18.5868722, 54.3540524],
        zoom: 15
      })

      const marker = new mapboxgl.Marker()
        .setLngLat([18.5868722, 54.3540524])
        .addTo(map)
    }
    return () => {
      if (map) map.remove()
    }
  }, [])

  const contactData = data.allContentfulKontakt.nodes[0]

  return (
    <>
      <div id="kontakt" className="section section-contact">
        <div className="contact-column">
          <h3 className="section-title">{contactData.title}</h3>
          <div className="contact-content">
            <div className="contact-text">
              <div dangerouslySetInnerHTML={{ __html: marked(contactData.description.description) }} />
            </div>
            <div className="contact-address">
              <div>
                telefon: <a href={`tel:${contactData.phone}`}>{contactData.phone}</a>
              </div>
              <div>
                e-mail: <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-column">
          <div id="map-container" />
        </div>
      </div>
    </>
  )
}

export default Contact
